export default __webpack_public_path__ + "static/open-sans-v15-latin-regular-87a454b233bedae23f8d1be11e8b4f68.woff";